<template>

  <div class="inputs-div">

    <b-card border-variant="info" header="教師あり学習データ Upload" class="text-center">
      <div
        v-if="dragShow"
        :class="dragAreaCls"
        @dragover.prevent="checkDrag($event, true)"
        @dragleave.prevent="checkDrag($event, false)"
      >
        <div class="drop-area" @drop.prevent="loadfile" download></div>
        <input type="file" @change="loadfile">
        <div class="drag-text"><b-icon icon="upload" variant="secondary" font-scale="4"></b-icon><br/><br/>
        学習する画像ファイルを<br/>ここにドラッグ＆ドロップ<br/><font size=-1>（Zipファイル１つでUploadして下さい）</font></div>
      </div>
      <div v-if="!dragShow">
        <div class="progText" v-if="progValue!=100"><strong>Loading...<b-spinner small variant="danger" label="Small Spinner" type="grow"></b-spinner>【{{progNum}}/{{progTotal}}】</strong></div>
        <div class="smallFont" v-if="progValue==100"><font color=red><strong>【{{progTotal}}枚 Load完了】</strong></font></div>
        <div v-if="progValue!=100" >
          <br/>
          <b-progress :value="progValue" max="100" striped animated></b-progress>
        </div>
        <br/>
      </div>
      <div id="imgss"></div>
    </b-card>

  </div>

</template>

<script>
import { mapState } from 'vuex'
import JSZip from 'jszip'
var imgFileArr = []
var imgDataArr = []

export default {
  name: 'inputupload',
  data () {
    return {
      modalFileShow: false,
      dragAreaCls: 'drag-area drag-area-normal',
      dragShow: true,
      imgss: null,
      width: 28,
      height: 28,
      curLabel: '',
      progTotal: 0,
      progNum: 0,
      progValue: 0,
      inputCount: -1,
      imgCount: 0
    }
  },
  computed: {
    ...mapState([ 'inputs', 'iimages' ])
  },
  methods: {
    checkDrag (event, status) {
      if (status && event.dataTransfer.types === 'text/plain') {
        // ファイルではなく、html要素をドラッグしてきた時は処理を中止
        return false
      }
      if (status) {
        this.dragAreaCls = 'drag-area drag-area-over'
      } else {
        this.dragAreaCls = 'drag-area drag-area-normal'
      }
    },
    async loadfile (event) {
      this.dragShow = false
      this.progTotal = 0
      this.progNum = 0
      this.progValue = 0
      this.$store.dispatch('setMessage', 'Loading....')
      // const fileList = event.target.files || event.dataTransfer.files
      const fileList = event.target.files || event.dataTransfer.files
      // ファイルが無い時は処理を中止
      if (fileList.length !== 1) {
        this.$store.dispatch('setMessage', 'Load失敗、ファイル全体を枠内に移動しドロップして下さい')
        return false
      }
      var inputCount = 0
      var allDirs = []
      var allFiles = []
      const tmpThis = this
      JSZip.loadAsync(fileList[0]).then(function (zip) {
        zip.forEach(function (relativePath, zipEntry) {
          // MACOSファイルやundefinedでないものを抽出
          if (!zipEntry.name.match(/__MACOSX/) && !zipEntry.name.match(/\.DS_Store/) && zipEntry.name !== 'undefined') {
            if (zipEntry.name.match(/^.+\/.+\/.+$/)) {
              // Inputデータ生成
              const spltName = zipEntry.name.split('/')
              var dirExist = true
              for (var i = 0; i < allDirs.length; i++) {
                if (spltName[1] === allDirs[i]) {
                  dirExist = false
                  break
                }
              }
              if (dirExist) {
                tmpThis.$store.dispatch('updLabel', {in_id: inputCount, in_label: spltName[1]})
                allDirs.push(spltName[1])
                inputCount++
                // console.log('allDirs1:' + spltName[1])
              }
            }
            if (zipEntry.name.match(/^.+\/.+\/.+\.(gif|png|jpg|jpeg)$/)) {
              allFiles.push(zipEntry.name)
              // console.log('allFiles:' + zipEntry.name)
            }
          }
        })
        tmpThis.progTotal = allFiles.length
        setTimeout(tmpThis.eachLoadZip(allDirs, allFiles, fileList[0]), 100)
      }, function (e) {
        tmpThis.$store.dispatch('setMessage', 'Load失敗、再度ページ更新後にファイルをドラッグして下さい')
      })
    },
    eachLoadZip (allDirs, allFiles, uploadf) {
      /* const tmpThis = this
      zipEntry.async('blob').then(function (imgData) {
        tmpThis.loadAddImg(imgData, zipEntry.name)
      }) */
      const tmpThis = this
      var fileCount = 0
      // ファイルの読み込みはディレクトリ単位にならない場合があるため、ディレクトリ単位でチェックし保存
      for (var i = 0; i < allDirs.length; i++) {
        const spltName1 = allDirs[i]
        for (var j = 0; j < allFiles.length; j++) {
          const lfile = allFiles[j]
          const spltName2 = allFiles[i].split('/')
          // console.log('DirFileCheck[' + spltName1 + '][' + spltName2[1] + ']')
          if (spltName1 === spltName2[1]) {
            JSZip.loadAsync(uploadf).then(function (zip) {
              return zip.file(lfile).async('blob')
            }).then(function (imgData) {
              tmpThis.loadStockImg(imgData, lfile) // waitをかけないと順番に読み込まれずディレクトリ単位の表示にならない
              fileCount++
              if (fileCount === allFiles.length) {
                tmpThis.loadAddImg()
                // console.log('loadAddImg!')
              }
            })
          }
        }
      }
      this.progValue = 100
      this.$store.dispatch('setMessage', 'Loadが完了しました')
    },
    loadStockImg (mgData, imgName) { // 順番通り処理するため一旦配列に格納
      imgFileArr.push(imgName)
      imgDataArr.push(mgData)
      // console.log('loadStockImg:' + imgName)
    },
    async loadAddImg () {
      for (var i = 0; i < imgFileArr.length; i++) {
        // 画像オブジェクトを生成(サイズ調整)
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = this.width
        canvas.height = this.height
        const img = await this.loadImage(URL.createObjectURL(imgDataArr[i])) // Blobからimgタグで使うurlを生成してImg作成(Load)
        ctx.drawImage(img, 0, 0, this.width, this.height)
        // canvas.id = 'canvas' + String(i + 1)
        canvas.style = 'margin: 2px; outline: black 1px solid;'
        // GrayScale
        var pixels = this.changeGrayscale(ctx.getImageData(0, 0, this.width, this.height))
        ctx.putImageData(pixels, 0, 0)
        // 画面表示
        const spltName = imgFileArr[i].split('/')
        if (spltName[1] !== this.curLabel) {
          this.curLabel = spltName[1]
          var div = document.createElement('div')
          div.innerHTML = 'Label【' + spltName[1] + '】'
          this.imgss.appendChild(div)
          this.inputCount++
          this.imgCount = 0
        }
        this.imgss.appendChild(canvas)
        // データ保存
        this.$store.dispatch('setImage', {
          s_in: this.inputCount,
          s_img: this.imgCount,
          s_data: canvas.toDataURL()
        })
        this.imgCount++
        this.progNum++
        this.progValue = Math.ceil(this.progNum / this.progTotal * 100)
      }
    },
    changeGrayscale (pixels) {
      for (var y = 0; y < pixels.height; y++) {
        for (var x = 0; x < pixels.width; x++) {
          var i = (y * 4) * pixels.width + x * 4
          var rgb = parseInt((pixels.data[i] + pixels.data[i + 1] + pixels.data[i + 2]) / 3, 10)
          pixels.data[i] = rgb
          pixels.data[i + 1] = rgb
          pixels.data[i + 2] = rgb
          pixels.data[i + 3] = 255
        }
      }
      return pixels
    },
    loadImage (dataUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = (e) => reject(e)
        img.src = dataUrl
      })
    }
  },
  mounted () {
    this.imgss = document.getElementById('imgss')
  }
}
</script>

<style scoped>
.drag-area {
  position: relative;
  width: 294px;
  height: 276px;
  margin: 0;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.drop-area {
  position: absolute;
  top: -50px;
  left: -50px;
  width: 394px;
  height: 376px;
  margin: 0;
  padding: 0;
  z-index: 99;
}
.drag-area-normal {
  border: 3px dotted #ddd;
  background-color: #F5F5F5;
}
.drag-area-over {
  border: 3px dotted #eee;
  background-color: #d3d3d3;
}
.drag-text {
  position: absolute;
  top: 50px;
  left: 25px;
}
input {
  opacity: 0;
  width: 100%;
  height: 270px;
}
.progText {
  color: red;
}
#imgss {
  max-height: 270px;
  overflow: auto;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/InputUpload.vue